import React from "react";

interface propsTypes{
  children?: React.ReactNode;
  className?:string;
}

const BlockQuotes = (props: propsTypes) => {
  const { children  } = props;

  return <blockquote {...props}>{children}</blockquote>;
};

export default BlockQuotes;
